import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SignatureIcon = React.forwardRef(function SignatureIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M1.68999 22C1.35999 22 1.02999 21.95 0.689994 21.83C0.169994 21.66 -0.120006 21.09 0.0599943 20.56C0.229994 20.04 0.799994 19.75 1.32999 19.93C2.26999 20.25 3.39999 19.25 4.56999 17.61C3.73999 17.55 3.00999 17.3 2.40999 16.89C0.429994 15.53 -0.410006 12.05 3.15999 6.32998C6.37999 1.15998 8.91 1.82998 9.84999 2.34998C11.94 3.51998 12.43 7.23998 10.9 10.31C10.22 11.68 9.53999 13.04 8.85999 14.31C10.77 13.18 12.97 11.24 15.21 8.24998C15.5 7.85998 16.04 7.73998 16.47 7.95998C16.9 8.18998 17.11 8.69998 16.95 9.15998C15.27 14.2 15.39 15.47 15.62 15.78C15.66 15.83 15.81 15.86 16 15.86C16.43 15.86 17.19 14.6 17.64 13.84C18.48 12.44 19.43 10.85 21 10.85C21.55 10.85 22 11.3 22 11.85C22 12.66 22.55 12.84 23.01 12.85C23.56 12.86 24 13.32 23.99 13.86C23.99 14.41 23.54 14.85 23 14.85C22.12 14.85 20.94 14.43 20.35 13.35C20 13.79 19.62 14.41 19.35 14.86C18.51 16.26 17.56 17.85 15.99 17.85C15.09 17.85 14.42 17.54 13.98 16.94C13.42 16.16 13.33 14.98 13.77 12.94C11.43 15.26 9.14999 16.66 7.15999 17.26C5.41999 20.05 3.63999 21.98 1.67999 21.98L1.68999 22ZM8.47999 4.00998C7.66999 4.00998 6.34999 4.98998 4.84999 7.38998C2.20999 11.62 2.27999 14.38 3.52999 15.24C4.04999 15.6 4.86999 15.72 5.88999 15.52C6.98999 13.64 8.09999 11.43 9.09999 9.40998C10.27 7.05998 9.76999 4.60998 8.85999 4.09998C8.74999 4.03998 8.61999 3.99998 8.46999 3.99998L8.47999 4.00998Z"></path>
    </svg>
  )
})

SignatureIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SignatureIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SignatureIcon
